import React from "react";
import { Link } from "react-router-dom";
import {
  PAGE_SHELL,
  PAGE_TITLE,
  PAGE_SUBTITLE,
  PANEL,
} from "../ui/pageChrome";

const Credentials = () => {
  return (
    <div className={PAGE_SHELL}>
      <div>
        <h1 className={PAGE_TITLE}>Credentials</h1>
        <p className={PAGE_SUBTITLE}>
          Review expired and missing employee credentials
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Link
          to="/credentials/expired"
          className={`${PANEL} block p-5 hover:bg-red-50/40 transition-colors text-center`}
        >
          <h2 className="text-lg font-semibold text-red-700">Expired Credentials</h2>
          <p className="text-slate-500 text-sm mt-1.5">View all expired employee credentials</p>
        </Link>

        <Link
          to="/credentials/missing"
          className={`${PANEL} block p-5 hover:bg-amber-50/40 transition-colors text-center`}
        >
          <h2 className="text-lg font-semibold text-amber-700">Missing Credentials</h2>
          <p className="text-slate-500 text-sm mt-1.5">View all missing employee credentials</p>
        </Link>
      </div>
    </div>
  );
};

export default Credentials;
